import { Component, OnInit, Input } from '@angular/core';
import { InformacaoService } from 'src/app/service/informacao/informacao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { MSG_OBG_TIPO_JUSTICA, MSG_OBG_NUM_PROCESSO, ERRO_CONSULTAR_PROCESSO } from 'src/app/tools/Mensagens';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'processo-informacao',
  templateUrl: './processo-informacao.component.html',
  styleUrls: ['./processo-informacao.component.css']
})
export class ProcessoInformacaoComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  checkedMarcado: boolean = false;
  listaClassificacaoComponente = [];
  charNum = 5000;
  isNotNumber = false;
  isNotValidNumeroProcesso = false;

  constructor(
    public service: InformacaoService,
    public desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) {
  }

  ngOnInit() {

    this.preencherListaClassificacao();

    if (!this.visualizacao && !this.edicao) {

      this.service.informacao.controls.descricaoInformacao.setValue('');
      this.service.informacao.controls.numeroProcesso.setValue(null);
      this.service.informacao.controls.comarca.setValue(null);
      this.service.informacao.controls.vara.setValue(null);
      this.service.informacao.controls.tipoDeJustica.setValue('');

    }

  }

  changeTipoJustica() {

    this.service.informacao.controls.numeroProcesso.enable();
    this.service.informacao.controls.numeroProcesso.setValue('');

  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.informacao.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.informacao.value.assunto.id);
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.informacao.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.informacao.controls[str].touched &&
      this.service.informacao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

  maskNumeroProcesso(numeroProcesso) {

    numeroProcesso = numeroProcesso.trim().replace(/\./g, '').replace(/-/g, '');

    if (numeroProcesso.length >= 13 && numeroProcesso.charAt(13) !== '8') {

      this.isNotValidNumeroProcesso = true;

      return;

    } else if (numeroProcesso.length >= 14 && numeroProcesso.charAt(14) !== '1') {

      this.isNotValidNumeroProcesso = true;

      return;

    } else if (numeroProcesso.length >= 15 && numeroProcesso.charAt(15) !== '3') {

      this.isNotValidNumeroProcesso = true;

      return;

    }

    this.isNotValidNumeroProcesso = numeroProcesso.length > 20;

    if (numeroProcesso && numeroProcesso.length >= 20 && numeroProcesso.length < 25) {

      let value = numeroProcesso;
      let resultado: any;
      value = value.toString();
      value = value.replace('-', '');
      value = value.replace('.', '');

      resultado = value.split('');
      resultado.splice(7, 0, '-');
      resultado.splice(10, 0, '.');
      resultado.splice(15, 0, '.');
      resultado.splice(17, 0, '.');
      resultado.splice(20, 0, '.');
      value = resultado.join('');

      this.service.informacao.controls.numeroProcesso.setValue(value);

    }

  }

  validaNumeroProcesso() {

    const regra = /^[0-9]*$/;
    const numero = this.service.informacao.value.numeroProcesso.trim().replace(/\./g, '').replace(/-/g, '');

    if (this.service.informacao.value.numeroProcesso && numero !== '') {

      if (numero.match(regra)) {

        this.isNotNumber = false;

      } else {

        this.isNotNumber = true;
        this.service.informacao.controls.numeroProcesso.setValue(numero.substring(0, numero.length - 1));

      }

    }

  }

  buscarProcesso() {

    if (!this.isNotValidNumeroProcesso) {

      if (this.service.informacao.value.tipoDeJustica === '' || this.service.informacao.value.tipoDeJustica == null) {
        alert(MSG_OBG_TIPO_JUSTICA);
      } else if (this.service.informacao.value.numeroProcesso === '' || this.service.informacao.value.numeroProcesso == null) {
        alert(MSG_OBG_NUM_PROCESSO);
      } else {
        this.service.buscarProcesso().subscribe(retorno => {
          if (retorno.comarca && retorno.vara) {
            this.service.informacao.controls.comarca.setValue(retorno.comarca);
            this.service.informacao.controls.vara.setValue(retorno.vara);
          } else {
            alert(ERRO_CONSULTAR_PROCESSO);
          }
        });
      }

    }

  }

}
